module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kszb-container"
  }, [_c('div', {
    staticClass: "kszb-box"
  }, [_c('div', {
    staticClass: "kszb-left"
  }, [_c('div', {
    staticClass: "kszb-section-title"
  }, [_vm._v(_vm._s(_vm.$t('all.jichushezhi')))]), _vm._v(" "), _c('div', {
    staticClass: "kszb-form-row"
  }, [_c('div', {
    staticClass: "kszb-form-item"
  }, [_c('span', {
    staticClass: "kszb-form-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojianbiaoti')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.title),
      expression: "form.title"
    }],
    staticClass: "kszb-form-item-input",
    attrs: {
      "placeholder": _vm.$t('all.geinidezhibojianqugemingziba')
    },
    domProps: {
      "value": (_vm.form.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "kszb-form-item-icon",
    attrs: {
      "src": require("../../../assets/image/bianji_28@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "kszb-form-item",
    on: {
      "click": function($event) {
        _vm.showBgModal = true
      }
    }
  }, [_c('span', {
    staticClass: "kszb-form-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojianbeijing')))]), _vm._v(" "), (_vm.form.backgroundUrl) ? _c('span', {
    staticClass: "kszb-form-item-value kszb-text-green"
  }, [_vm._v(_vm._s(_vm.$t('all.yishangchuan')))]) : _c('span', {
    staticClass: "kszb-form-item-value"
  }, [_vm._v(_vm._s(_vm.$t('all.qingshangchuan')))]), _vm._v(" "), _c('img', {
    staticClass: "kszb-form-item-icon",
    attrs: {
      "src": require("../../../assets/image/shangchuan_28@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "kszb-form-row"
  }, [_c('div', {
    staticClass: "kszb-form-item kszb-form-item-select",
    on: {
      "click": function($event) {
        _vm.showCategoryDropdown = !_vm.showCategoryDropdown
      }
    }
  }, [_c('span', {
    staticClass: "kszb-form-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojianbiaoqian')))]), _vm._v(" "), _c('span', {
    staticClass: "kszb-form-item-value"
  }, [_vm._v(_vm._s(_vm.form.categoryName || _vm.$t('all.qingxuanze')))]), _vm._v(" "), _c('img', {
    staticClass: "kszb-form-item-icon",
    attrs: {
      "src": require("../../../assets/image/biaoqian_28@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.showCategoryDropdown) ? _c('div', {
    staticClass: "kszb-dropdown",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, _vm._l((_vm.categoryList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "kszb-dropdown-item",
      class: {
        'kszb-dropdown-item-active': _vm.form.categoryId === item.id
      },
      on: {
        "click": function($event) {
          return _vm.handleSelectCategory(item)
        }
      }
    }, [_vm._v(_vm._s(item.categoryName))])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "kszb-form-item"
  }, [_c('span', {
    staticClass: "kszb-form-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojinyao')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.liveKey),
      expression: "form.liveKey"
    }],
    staticClass: "kszb-form-item-input",
    attrs: {
      "placeholder": _vm.$t('all.qingshurukaibomiyao')
    },
    domProps: {
      "value": (_vm.form.liveKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "liveKey", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "kszb-form-item-icon",
    attrs: {
      "src": require("../../../assets/image/jinyao_28@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "kszb-quality-row"
  }, _vm._l((_vm.qualityList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.qualityIndex === index ? 'kszb-quality-active' : 'kszb-quality',
      on: {
        "click": function($event) {
          _vm.qualityIndex = index
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "kszb-btn",
    on: {
      "click": _vm.handleStart
    }
  }, [_vm._v(_vm._s(_vm.$t('all.kaishizhibo')))])])]), _vm._v(" "), (_vm.showBgModal) ? _c('div', {
    staticClass: "kszb-bg-overlay",
    on: {
      "click": function($event) {
        _vm.showBgModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showBgModal) ? _c('div', {
    staticClass: "kszb-bg-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "kszb-bg-modal-header"
  }, [_c('span', {
    staticClass: "kszb-bg-modal-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xuanzebackground')))]), _vm._v(" "), _c('img', {
    staticClass: "kszb-bg-modal-close",
    attrs: {
      "src": require("../../../assets/image/tanchuang_x_b@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showBgModal = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "kszb-bg-modal-body"
  }, [(_vm.selectedBgUrl) ? _c('div', {
    staticClass: "kszb-bg-preview"
  }, [_c('span', {
    staticClass: "kszb-bg-preview-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yixuanze')))]), _vm._v(" "), _c('img', {
    staticClass: "kszb-bg-preview-img",
    attrs: {
      "src": _vm.selectedBgUrl,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kszb-bg-grid"
  }, [_c('div', {
    staticClass: "kszb-bg-item kszb-bg-item-upload",
    on: {
      "click": _vm.handleUploadBg
    }
  }, [_c('div', {
    staticClass: "kszb-bg-upload-icon"
  }, [_vm._v("+")]), _vm._v(" "), _c('span', {
    staticClass: "kszb-bg-upload-text"
  }, [_vm._v(_vm._s(_vm.$t('all.shangchuanbeijing')))]), _vm._v(" "), _c('input', {
    ref: "bgInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handleBgChange
    }
  })]), _vm._v(" "), _vm._l((_vm.bgList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "kszb-bg-item",
      class: {
        'kszb-bg-item-active': _vm.selectedBgUrl === item.imgUrl
      },
      on: {
        "click": function($event) {
          return _vm.handleSelectBg(item)
        }
      }
    }, [_c('img', {
      staticClass: "kszb-bg-img",
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    })])
  })], 2)]), _vm._v(" "), (_vm.uploadProgress > 0 && _vm.uploadProgress < 100) ? _c('div', {
    staticClass: "kszb-bg-progress"
  }, [_c('div', {
    staticClass: "kszb-bg-progress-bar"
  }, [_c('div', {
    staticClass: "kszb-bg-progress-fill",
    style: ({
      width: _vm.uploadProgress + '%'
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "kszb-bg-progress-text"
  }, [_vm._v(_vm._s(_vm.uploadProgress) + "%")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kszb-bg-modal-footer"
  }, [_c('div', {
    staticClass: "kszb-bg-modal-cancel",
    on: {
      "click": function($event) {
        _vm.showBgModal = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.quxiao')))]), _vm._v(" "), _c('div', {
    staticClass: "kszb-bg-modal-confirm",
    on: {
      "click": _vm.handleConfirmBg
    }
  }, [_vm._v(_vm._s(_vm.$t('all.queren')))])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09097e58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/kaishizhibo/kaishizhibo.vue
// module id = 948
// module chunks = 1